import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5c60538"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["required"]
const _hoisted_2 = {
  key: 0,
  value: ""
}
const _hoisted_3 = ["value"]

import useVModelDefaultVar from '@/services/composables/VModelDefaultVar';
import {computed} from 'vue';
export type DropdownModelType<T, TS extends string | undefined = undefined> = TS extends undefined ? T : T|null;
export interface DropdownArrayProps<T, TS extends string | undefined = undefined> {
    modelValue?: DropdownModelType<T, TS>;
    placeholder?: TS;
    options: T[];
    required?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownTopArray',
  props: {
    modelValue: {},
    placeholder: {},
    options: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const mv = useVModelDefaultVar(props as { modelValue?: T|null }, emits, 'modelValue',  props.modelValue ?? (props.placeholder ? null : props.options[0]));
const nullWrapper = computed({
    get() {
        return mv.value === null ? "" : mv.value;
    },
    set(val: (typeof mv.value | "")) {
        //@ts-expect-error FIX THIS LATER
        mv.value = val === "" ? null : val;
    }
});
const options = computed(()=>[... new Set(props.options)].sort());

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nullWrapper).value = $event)),
    class: "dropdown",
    required: _ctx.required
  }, [
    (_ctx.placeholder)
      ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(_ctx.placeholder), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (k, i) => {
      return (_openBlock(), _createElementBlock("option", {
        key: i,
        value: k
      }, [
        _renderSlot(_ctx.$slots, k, { value: k }, () => [
          _createTextVNode(_toDisplayString(k), 1)
        ])
      ], 8, _hoisted_3))
    }), 128))
  ], 8, _hoisted_1)), [
    [_vModelSelect, nullWrapper.value]
  ])
}
}

})